module.exports = __webpack_public_path__ + "f117e78365910bda839d16b8482e6b15.png";